// JOBE-0044.14: cold-start empty variant. "Nothing yet." (Instrument
// Serif italic) + an explanatory paragraph per umbrella R9. The copy
// must not imply error — seed deployments may legitimately have empty
// /api/entities responses.

export function EmptyState() {
  return (
    <div
      className="library-table-empty library-state-empty"
      data-state="empty"
    >
      <p className="library-state-empty-headline">Nothing yet.</p>
      <p className="library-state-empty-body">
        Entities appear here as they're produced. Briefings land at
        07:00, reports as you commit them, and agents on every run.
      </p>
    </div>
  );
}
